import {
  mdiScaleBalance,
  mdiCompassOutline,
  mdiPillar,
  mdiTools,
  mdiAccountPlusOutline,
  mdiAccountMultipleOutline,
  mdiRobot,
  mdiLighthouse,
  mdiBookshelf,
  mdiTextBoxCheckOutline,
  mdiLink,
} from '@mdi/js';

interface DevDocLink {
  link: string;
  icon: string;
  title: string;
  description: string;
  externalIcon?: string;
}
export const DOCS_BASE_URL = '/docs/default/component/equinor-developer';

export const devDocLinks: DevDocLink[] = [
  {
    link: `${DOCS_BASE_URL}/governance/`,
    icon: mdiScaleBalance,
    title: 'Governance',
    description: 'Governing documents, policies and strategies.',
  },
  {
    link: `${DOCS_BASE_URL}/guidelines/`,
    icon: mdiCompassOutline,
    title: 'Guidelines',
    description: 'Guidelines for software development.',
  },
  {
    link: `${DOCS_BASE_URL}/ai-guidance/`,
    icon: mdiRobot,
    title: 'AI Guidance',
    description: 'Governance, guidelines and other info about AI in software development.',
  },
  {
    link: `${DOCS_BASE_URL}/platforms/`,
    icon: mdiPillar,
    title: 'IT Platforms',
    description: 'Equinor IT Platforms for software development.',
  },
  {
    link: `${DOCS_BASE_URL}/tools-and-dependencies/tools/`,
    icon: mdiTools,
    title: 'Tools and Dependencies',
    description: 'How to select, introduce and monitor software tools and dependencies in Equinor.',
  },
  {
    link: `${DOCS_BASE_URL}/enabling-teams/`,
    icon: mdiAccountPlusOutline,
    title: 'Enabling Teams',
    description: 'Teams working to enable application development teams.',
  },
  {
    link: `${DOCS_BASE_URL}/community/`,
    icon: mdiAccountMultipleOutline,
    title: 'Community',
    description: 'The community of software developers in Equinor.',
  },
  {
    link: 'https://equinor.service-now.com/selfservice?id=kb_article&table=kb_knowledge&sysparm_article=KB0047312',
    icon: mdiTextBoxCheckOutline,
    title: 'Architecture Contract',
    description: 'A mandatory support dialogue for software development activities.',
    externalIcon: mdiLink,
  },
  {
    link: `${DOCS_BASE_URL}/digital-direction/`,
    icon: mdiLighthouse,
    title: 'Equinor Digital Direction',
    description: 'Empowering faster and better decisions about IT and data.',
  },
  {
    link: `${DOCS_BASE_URL}/other-resources/`,
    icon: mdiBookshelf,
    title: 'Links and Other Resources',
    description: 'Administrative applications, external links, etc.',
  },
];
